module.exports = __webpack_public_path__ + "img/clock_speed_full.5b4e882a.png";